import uRLs from "../utils/baseUtils";
import { formatCurrencyFun } from "../utils/formatCurrencyFunc";

export const FormatedTemplateData = (sale, storeSettings) => {
     const convert = (value) =>
    formatCurrencyFun(value);
const formattedReturnSaleData = sale?.returnSaleData
  ? {
      ...sale.returnSaleData,

      customerData: sale.returnSaleData?.CustomerInfo,

      returnSaleItems: sale.returnSaleData?.returnItems?.map((item) => ({
        ...item,
        mrp: convert(item?.mrp),
        salePrice: convert(item?.salePrice),
        soldPrice: convert(item?.soldPrice),
        returnPrice: convert(item?.returnPrice),
        cancelledPrice: convert(item?.cancelledPrice),
        basePrice: convert(item?.basePrice),
        discount: convert(item?.discount),
        taxAmount: convert(item?.taxAmount),
        sgstAmount: convert(item?.sgstAmount),
        cgstAmount: convert(item?.cgstAmount),
        igstAmount: convert(item?.igstAmount),

        lineTotalMrp: convert(item?.lineTotalMrp),
        lineTotalSalePrice: convert(item?.lineTotalSalePrice),
        lineTotalSoldPrice: convert(item?.lineTotalSoldPrice),
        lineTotalCancelledPrice: convert(item?.lineTotalCancelledPrice),
        lineTotalDiscount: convert(item?.lineTotalDiscount),
        lineTotalBasePrice: convert(item?.lineTotalBasePrice),
        lineTotalTaxAmount: convert(item?.lineTotalTaxAmount),
        lineTotalSgstAmount: convert(item?.lineTotalSgstAmount),
        lineTotalCgstAmount: convert(item?.lineTotalCgstAmount),
        lineTotalIgstAmount: convert(item?.lineTotalIgstAmount),
        lineGrandTotal: convert(item?.lineGrandTotal),
      })),
       paidAmount: convert(sale?.returnSaleData?.paidamount),
      totalMrp: convert(sale.returnSaleData?.totalmrp),
      totalSalePrice: convert(sale.returnSaleData?.totalsaleprice),
      totalSoldPrice: convert(sale.returnSaleData?.totalsoldprice),
      totalBasePrice: convert(sale.returnSaleData?.totalbaseprice),
      totalDiscount: convert(sale.returnSaleData?.totaldiscount),
      totalTaxAmount: convert(sale.returnSaleData?.totaltaxamount),

      returnGrandTotalRounded: convert(
        sale.returnSaleData?.returnGrandTotalRounded
      ),
      balanceDue: convert(sale?.paymentInfo?.refundPaymentMethods?.PAYLATER),
      upiPaid: convert(sale?.paymentInfo?.refundPaymentMethods?.UPI),
      cashPaid: convert(sale?.paymentInfo?.refundPaymentMethods?.CASH),
      onlinePaid: convert(sale?.paymentInfo?.refundPaymentMethods?.ONLINE),
      cardPaid: convert(sale?.paymentInfo?.refundPaymentMethods?.CARD),
      sgstAmount: convert(sale.returnSaleData?.returnSgstamount),
      cgstAmount: convert(sale.returnSaleData?.returnCgstamount),
      igstAmount: convert(sale.returnSaleData?.returnIgstamount),

      totalReturnAmount: convert(sale.returnSaleData?.totalReturnAmount),

      actualAmountRefunded: convert(
        sale.returnSaleData?.actualAmountRefunded
      ),

      amountinwordsTotalReturnAmount:
        sale.returnSaleData?.amountinwordsTotalReturnAmount,

      amountinwordsReturnRounded:
        sale.returnSaleData?.amountinwordsReturnRounded,
    }
  : undefined;
  const formattedPreSaleData = sale?.preSaleData
    ? {
        ...sale.preSaleData,
        overallDiscount:convert(sale?.preSaleData?.overallDiscount?.overallDiscountAmount),
        grandTotal: convert(sale.preSaleData?.grandTotal),
        balanceDue: convert(sale?.preSaleData?.paylateramount - sale?.preSaleData?.paylaterchange),
        totalTaxAmount: convert(sale.preSaleData?.totalTaxAmount),
        totalBasePrice: convert(sale.preSaleData?.totalBasePrice),
        totalSoldPrice: convert(sale.preSaleData?.totalSoldPrice),
        totalSalePrice: convert(sale.preSaleData?.totalSalePrice),
        totalDiscount: convert(sale.preSaleData?.totalDiscount),
        sgstAmount: convert(sale.preSaleData?.sgstAmount),
        cgstAmount: convert(sale.preSaleData?.cgstAmount),
        igstAmount: convert(sale.preSaleData?.igstAmount),   
        totalMrp:convert(sale.preSaleData?.totalMrp),
        paidAmount: convert(sale?.preSaleData?.paidamount),
        preSaleItems: sale.preSaleData?.preSaleItems?.map((item) => ({
          ...item,
          mrp: convert(item?.mrp),
          saleprice: convert(item?.saleprice),
          soldprice: convert(item?.soldprice),
          baseprice: convert(item?.baseprice),
          discount: convert(item?.discount),
          taxamount: convert(item?.taxamount),
          sgstAmount: convert(item?.sgstAmount),
          cgstAmount: convert(item?.cgstAmount),
          igstAmount: convert(item?.igstAmount),
          lineTotalMrp: convert(item?.lineTotalMrp),
          lineTotalSalePrice: convert(item?.lineTotalSalePrice),
          lineTotalSoldPrice: convert(item?.lineTotalSoldPrice),
          lineTotalDiscount: convert(item?.lineTotalDiscount),
          lineTotalBasePrice: convert(item?.lineTotalBasePrice),
          lineTotalTaxAmount: convert(item?.lineTotalTaxAmount),
          lineTotalSgstAmount: convert(item?.lineTotalSgstAmount),
          lineTotalCgstAmount: convert(item?.lineTotalCgstAmount),
          lineTotalIgstAmount: convert(item?.lineTotalIgstAmount),
          lineGrandTotal: convert(item?.lineGrandTotal),
          lineTotalLandingCost: convert(item?.lineTotalLandingCost),
        })),
      }
    : undefined;

  const getPaymentAmount = (paymentMode, mode) => {
    if (!Array.isArray(paymentMode)) return "0";
    return paymentMode
      .filter((payment) => payment?.mode === mode)
      .reduce((total, payment) =>convert(payment?.amount), "₹0.00");
  };

 const formattedPurchaseData = sale?.purchaseNo
  ? {
      ...sale,
      purchaseNo:sale?.purchaseNo,
      purchaseDate: sale?.purchaseDate,

      purchaseItems: sale?.purchaseItems?.map((item) => ({
        ...item,

        purchaseMrp: convert(item?.purchaseMrp),
        purchaseDiscount: convert(item?.purchaseDiscount),
        purchasePriceWithTax: convert(item?.purchasePriceWithTax),
        purchasePriceWithoutTax: convert(item?.purchasePriceWithoutTax),

        purchaseGstAmount: convert(item?.purchaseGstAmount),
        purchaseTaxAmount: convert(item?.purchaseTaxAmount),
        purchaseSgstAmount: convert(item?.purchaseSgstAmount),
        purchaseCgstAmount: convert(item?.purchaseCgstAmount),
        purchaseIgstAmount: convert(item?.purchaseIgstAmount),

        lineTotalPurchaseMrp: convert(item?.lineTotalPurchaseMrp),
        lineTotalPurchaseDiscount: convert(
          item?.lineTotalPurchaseDiscount
        ),
        lineTotalPurchasePriceWithTax: convert(
          item?.lineTotalPurchasePriceWithTax
        ),
        lineTotalPurchasePriceWithoutTax: convert(
          item?.lineTotalPurchasePriceWithoutTax
        ),
        lineTotalPurchaseTaxAmount: convert(
          item?.lineTotalPurchaseTaxAmount
        ),
        lineTotalPurchaseSgstAmount: convert(
          item?.lineTotalPurchaseSgstAmount
        ),
        lineTotalPurchaseCgstAmount: convert(
          item?.lineTotalPurchaseCgstAmount
        ),
        lineTotalPurchaseIgstAmount: convert(
          item?.lineTotalPurchaseIgstAmount
        ),
        lineGrandPurchaseTotal: convert(
          item?.lineGrandPurchaseTotal
        ),

        // Sale amount list
        saleAmountList: item?.saleAmountList
          ? {
              ...item.saleAmountList,

              mrp: convert(item.saleAmountList?.mrp),
              discount: convert(item.saleAmountList?.discount),
              salePrice: convert(item.saleAmountList?.salePrice),
              basePrice: convert(item.saleAmountList?.basePrice),

              gstAmount: convert(item.saleAmountList?.gstAmount),
              taxAmount: convert(item.saleAmountList?.taxAmount),
              sgstAmount: convert(item.saleAmountList?.sgstAmount),
              cgstAmount: convert(item.saleAmountList?.cgstAmount),
              igstAmount: convert(item.saleAmountList?.igstAmount),

              lineTotalMrp: convert(item.saleAmountList?.lineTotalMrp),
              lineTotalDiscount: convert(
                item.saleAmountList?.lineTotalDiscount
              ),
              lineTotalSalePrice: convert(
                item.saleAmountList?.lineTotalSalePrice
              ),
              lineTotalBasePrice: convert(
                item.saleAmountList?.lineTotalBasePrice
              ),
              lineTotalTaxAmount: convert(
                item.saleAmountList?.lineTotalTaxAmount
              ),
              lineTotalSgstAmount: convert(
                item.saleAmountList?.lineTotalSgstAmount
              ),
              lineTotalCgstAmount: convert(
                item.saleAmountList?.lineTotalCgstAmount
              ),
              lineTotalIgstAmount: convert(
                item.saleAmountList?.lineTotalIgstAmount
              ),
              lineGrandTotal: convert(
                item.saleAmountList?.lineGrandTotal
              ),
            }
          : undefined,
      })),
      
      purchaseServices: sale?.purchaseServices?.map(
        (item) => ({
          ...item,

          saleprice: convert(item?.saleprice),
          baseprice: convert(item?.baseprice),

          purchaseMrp: convert(item?.purchaseMrp),
          purchaseDiscount: convert(item?.purchaseDiscount),
          purchasePriceWithTax: convert(item?.purchasePriceWithTax),
          purchasePriceWithoutTax: convert(
            item?.purchasePriceWithoutTax
          ),

          purchaseGstAmount: convert(item?.purchaseGstAmount),
          purchaseTaxAmount: convert(item?.purchaseTaxAmount),
          purchaseSgstAmount: convert(item?.purchaseSgstAmount),
          purchaseCgstAmount: convert(item?.purchaseCgstAmount),
          purchaseIgstAmount: convert(item?.purchaseIgstAmount),

          lineTotalPurchaseAmountWithTax: convert(
            item?.lineTotalPurchaseAmountWithTax
          ),
          lineTotalPurchaseAmountWithOutTax: convert(
            item?.lineTotalPurchaseAmountWithOutTax
          ),

          lineTotalPurchaseMrp: convert(
            item?.lineTotalPurchaseMrp
          ),
          lineTotalPurchaseDiscount: convert(
            item?.lineTotalPurchaseDiscount
          ),
          lineTotalPurchasePriceWithTax: convert(
            item?.lineTotalPurchasePriceWithTax
          ),
          lineTotalPurchasePriceWithoutTax: convert(
            item?.lineTotalPurchasePriceWithoutTax
          ),
          lineTotalPurchaseTaxAmount: convert(
            item?.lineTotalPurchaseTaxAmount
          ),
          lineTotalPurchaseSgstAmount: convert(
            item?.lineTotalPurchaseSgstAmount
          ),
          lineTotalPurchaseCgstAmount: convert(
            item?.lineTotalPurchaseCgstAmount
          ),
          lineTotalPurchaseIgstAmount: convert(
            item?.lineTotalPurchaseIgstAmount
          ),
          lineGrandPurchaseTotal: convert(
            item?.lineGrandPurchaseTotal
          ),

          saleAmountList: item?.saleAmountList
            ? {
                ...item.saleAmountList,

                mrp: convert(item.saleAmountList?.mrp),
                discount: convert(item.saleAmountList?.discount),
                salePrice: convert(item.saleAmountList?.salePrice),
                basePrice: convert(item.saleAmountList?.basePrice),
                gstAmount: convert(item.saleAmountList?.gstAmount),
                taxAmount: convert(item.saleAmountList?.taxAmount),
                sgstAmount: convert(item.saleAmountList?.sgstAmount),
                cgstAmount: convert(item.saleAmountList?.cgstAmount),
                igstAmount: convert(item.saleAmountList?.igstAmount),

                lineTotalMrp: convert(
                  item.saleAmountList?.lineTotalMrp
                ),
                lineTotalDiscount: convert(
                  item.saleAmountList?.lineTotalDiscount
                ),
                lineTotalSalePrice: convert(
                  item.saleAmountList?.lineTotalSalePrice
                ),
                lineTotalBasePrice: convert(
                  item.saleAmountList?.lineTotalBasePrice
                ),
                lineTotalTaxAmount: convert(
                  item.saleAmountList?.lineTotalTaxAmount
                ),
                lineTotalSgstAmount: convert(
                  item.saleAmountList?.lineTotalSgstAmount
                ),
                lineTotalCgstAmount: convert(
                  item.saleAmountList?.lineTotalCgstAmount
                ),
                lineTotalIgstAmount: convert(
                  item.saleAmountList?.lineTotalIgstAmount
                ),
                lineGrandTotal: convert(
                  item.saleAmountList?.lineGrandTotal
                ),
              }
            : undefined,
        })
      ),

      totalPurchaseMrp: convert(
        sale?.totalPurchaseMrp
      ),
      totalPurchasePrice: convert(
        sale?.totalPurchasePrice
      ),
      totalPurchasePriceWithoutTax: convert(
        sale?.totalPurchasePriceWithoutTax
      ),
      totalPurchaseDiscount: convert(
        sale?.totalPurchaseDiscount
      ),
      totalPurchaseTaxAmount: convert(
        sale?.totalPurchaseTaxAmount
      ),

      grandTotal: convert(
        sale?.grandTotal?.grandtotal ??
          sale?.totalAmount ??
          sale?.totalPurchasePrice
      ),

      sgstPurchaseAmount: convert(
        sale?.grandTotal?.sgstPurchaseAmount
      ),
      cgstPurchaseAmount: convert(
        sale?.grandTotal?.cgstPurchaseAmount
      ),
      igstPurchaseAmount: convert(
        sale?.grandTotal?.igstPurchaseAmount
      ),

      amountInWords:
        sale?.grandTotal?.purchaseAmountInWords ??
        sale?.grandTotal?.totalPurchasePriceInWords,
      balanceDue: convert(sale?.balanceAmount),

      upiPaid: getPaymentAmount(sale?.paymentMode, "UPI"),

      cashPaid: getPaymentAmount(sale?.paymentMode, "CASH"),

      onlinePaid: getPaymentAmount(sale?.paymentMode, "ONLINE"),

      cardPaid: getPaymentAmount(sale?.paymentMode, "CARD"), 
      totalAmount: convert(sale?.totalAmount),
    }
  : undefined;
  const result = {
    ...sale,
    preSaleData: formattedPreSaleData,
    returnSaleData: formattedReturnSaleData,
    purchaseData: formattedPurchaseData,
    saledate: sale?.saledate,
    storeSettings: storeSettings,
    negobillBranding: storeSettings?.negobillBranding,
    terms: storeSettings?.invoiceSettings?.termsAndConditions,
    signimg: uRLs.IMAGE_URL + storeSettings?.invoiceSettings?.signature,
    signature: storeSettings?.invoiceSettings?.signature,
    image: sale?.salefrom?.image,
    totalqty: sale?.saleitems?.length || 0,
    saleitems: sale?.saleitems?.map((item) => ({
      ...item,
      mrp: convert(item?.mrp),
      saleprice: convert(item?.saleprice),
      soldprice: convert(item?.soldprice),
      baseprice: convert(item?.baseprice),
      discount: convert(item?.discount),
      taxamount: convert(item?.taxamount),
      sgstAmount: convert(item?.sgstAmount),
      cgstAmount: convert(item?.cgstAmount),
      igstAmount: convert(item?.igstAmount),
      lineTotalMrp: convert(item?.lineTotalMrp),
      lineTotalSalePrice: convert(item?.lineTotalSalePrice),
      lineTotalSoldPrice: convert(item?.lineTotalSoldPrice),
      lineTotalDiscount: convert(item?.lineTotalDiscount),
      lineTotalBasePrice: convert(item?.lineTotalBasePrice),
      lineTotalTaxAmount: convert(item?.lineTotalTaxAmount),
      lineTotalSgstAmount: convert(item?.lineTotalSgstAmount),
      lineTotalCgstAmount: convert(item?.lineTotalCgstAmount),
      lineTotalIgstAmount: convert(item?.lineTotalIgstAmount),
      lineGrandTotal: convert(item?.lineGrandTotal),
      lineTotalLandingCost: convert(item?.lineTotalLandingCost),
    })),
    overallDiscount:convert(sale?.overallDiscount?.overallDiscountAmount),
    totalmrp: convert(sale?.totalmrp),
    totalsaleprice: convert(sale?.totalsaleprice),
    totalsoldprice: convert(sale?.totalsoldprice),
    totalbaseprice: convert(sale?.totalbaseprice),
    totaldiscount: convert(sale?.totaldiscount),
    totaltaxamount: convert(sale?.totaltaxamount),
    grandtotal: convert(sale?.grandtotal),
    sgstamount: convert(sale?.sgstamount),
    cgstamount: convert(sale?.cgstamount),
    igstamount: convert(sale?.igstamount),
    cashamount: sale?.cashamount,
    cashchange: sale?.cashchange,
    cashPaid: convert(sale?.cashamount - sale?.cashchange),
    cardamount: sale?.cardamount,
    cardchange: sale?.cardchange,
    cardPaid: convert(sale?.cardamount - sale?.cardchange),
    onlineamount: sale?.onlineamount,
    onlinechange: sale?.onlinechange,
    onlinePaid: convert(sale?.onlineamount - sale?.onlinechange),
    upiamount: sale?.upiamount,
    upichange: sale?.upichange,
    upiPaid: convert(sale?.upiamount - sale?.upichange),
    paylateramount: sale?.paylateramount,
    paylaterchange: sale?.paylaterchange,
    balanceDue: convert(sale?.paylateramount - sale?.paylaterchange),
    waveoffamount: sale?.waveoffamount,
    waveoffchange: sale?.waveoffchange,
    changeamount: sale?.changeamount,
    bankDetails: storeSettings?.paymentSettings?.bankDetails,
    upiId: storeSettings?.paymentSettings?.upiId,
    upiQrLink: storeSettings?.paymentSettings?.upiQrLink,
    paidAmount: convert(sale?.paidamount),
    paymentInfo: Array.isArray(sale?.paymentInfo)
  ? sale.paymentInfo.map((pay) => ({
      ...pay,
      amount: convert(pay?.amount),
    }))
  : sale?.paymentInfo
    ? {
        ...sale.paymentInfo,
        totalAmountRefunded: convert(sale.paymentInfo.totalAmountRefunded),
        totalRefundPending: convert(sale.paymentInfo.totalRefundPending),
        returnGrandTotalRounded: convert(
          sale.paymentInfo.returnGrandTotalRounded
        ),
      }
    : undefined,
    // paymentInfo: sale?.paymentInfo?.map((pay) => ({
    //   ...pay,
    //   amount: convert(pay?.amount),
    // })),
  };

  // Log the final formatted object to the console
  // console.log("Formatted Template Data:", result);

  return result;
};